import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

export interface PlatformInfo {
  isNative: boolean;
  isIOS: boolean;
  isAndroid: boolean;
  isWeb: boolean;
  platform: 'ios' | 'android' | 'web';
}

export function usePlatform(): PlatformInfo {
  const [platformInfo, setPlatformInfo] = useState<PlatformInfo>(() => {
    const isNative = Capacitor.isNativePlatform();
    const platform = Capacitor.getPlatform();
    
    return {
      isNative,
      isIOS: platform === 'ios',
      isAndroid: platform === 'android',
      isWeb: !isNative,
      platform: (platform === 'ios' ? 'ios' : platform === 'android' ? 'android' : 'web') as 'ios' | 'android' | 'web',
    };
  });

  useEffect(() => {
    // Re-check on mount to ensure accurate detection
    const isNative = Capacitor.isNativePlatform();
    const platform = Capacitor.getPlatform();
    
    setPlatformInfo({
      isNative,
      isIOS: platform === 'ios',
      isAndroid: platform === 'android',
      isWeb: !isNative,
      platform: (platform === 'ios' ? 'ios' : platform === 'android' ? 'android' : 'web') as 'ios' | 'android' | 'web',
    });
  }, []);

  return platformInfo;
}


